import { defineComponent as _defineComponent } from 'vue'
import OtpComponent from "@/components/buyTokens/OtpComponent.vue";
import {ref} from "vue";
import {useUserServiceStore} from "@/store/userService.store";
import {useToast} from "vue-toastification";
import {useRouter} from "vue-router";
import apiFactory from "@/api/factory.api";
import {useContextStore} from "@/store/context.store";
import {AddressType} from "@/components/buyTokens/modals/AddressType";
import {useUserStore} from "@/store/user.store";
import message from "@/config/message";
import {formatString} from "@/utils/string-formatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProvideVerificationCodeView',
  setup(__props, { expose: __expose }) {
  __expose();


const activationCode = ref<string>('');
const contextStore = useContextStore();
const onActivateClick = () => {
  const processID = contextStore.dataToSign?.processID;
  if(contextStore.addressType == AddressType.METAMASK) {
    const dataToSign = formatString(message.PAIRING_EMAIL_METAMASK_WALLET_MESSAGE, {email: useUserServiceStore().userEmail, address: useUserStore().metamaskConnectionInfo.address,  activationCode: activationCode.value, randomString: contextStore.dataToSign?.dataToSign.randomString});
    if(processID)
      apiFactory.accountApi().signMetamask(dataToSign).then(signedDataResponse => {
        if(signedDataResponse.isSuccess() && signedDataResponse.data) {
          useUserServiceStore().emailMetamaskPairingDataVerify(processID, signedDataResponse.data, onSuccess, onError);
        }
      });
  } else if(contextStore.addressType == AddressType.KEPLR) {
    if(processID ) {
      const dataToSign = formatString(message.PAIRING_EMAIL_COSMOS_WALLET_MESSAGE, {email: useUserServiceStore().userEmail, address: useUserStore().connectionInfo.account,  activationCode: activationCode.value, randomString: contextStore.dataToSign?.dataToSign.randomString});
      apiFactory.accountApi().sign(useUserStore().connectionInfo, dataToSign).then(signedDataResponse => {

        if(signedDataResponse.isSuccess() && signedDataResponse.data) {

          useUserServiceStore().emailKeplrPairingDataVerify(processID, signedDataResponse.data, onSuccess, onError);
        }
      });
    }
  }
};
const toast = useToast();
const router = useRouter();
const onSuccess = () => {
  if(contextStore.addressType == AddressType.METAMASK) {
    toast.success('Metamask connected');
  } else if (contextStore.addressType == AddressType.KEPLR) {
    toast.success('Keplr connected');
  }

  router.back();
};
const onError = (errorMessage?: string) => {
  toast.error('An error occurred \n' + errorMessage);
  router.back();
};

const __returned__ = { activationCode, contextStore, onActivateClick, toast, router, onSuccess, onError, OtpComponent, get useUserServiceStore() { return useUserServiceStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})